/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Cards_Printings_Copies_DescriptionInputs */



/**
* | output |
* | --- |
* | "What a card, a printing, and a copy are, and how the three levels connect." |
*
* @param {Help_Article_Cards_Printings_Copies_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_cards_printings_copies_description = /** @type {((inputs?: Help_Article_Cards_Printings_Copies_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Cards_Printings_Copies_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was eine Karte, ein Druck und ein Exemplar sind und wie die drei Ebenen zusammenhängen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce qu'est une carte, une édition et un exemplaire, et comment ces trois niveaux s'articulent.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("什么是卡牌、印刷版本和实体卡，以及这三个层级如何相互关联。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("什麼是卡牌、印刷版本與實體卡，以及這三個層級如何串起來。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드와 인쇄판, 사본이 각각 무엇이고 세 단계가 어떻게 이어지는지 설명합니다.")
	return /** @type {LocalizedString} */ ("What a card, a printing, and a copy are, and how the three levels connect.")
});